import { PerspectiveGroupingRule } from '@ardoq/perspectives';
import { RuleNotificationType } from '@ardoq/query-builder';

export const getSidebarGroupingRuleNotificationParamsFunction =
  (rulesIdsWithWarnings: string[]) => (rule: PerspectiveGroupingRule) => {
    if (rulesIdsWithWarnings.includes(rule.id)) {
      return {
        message: <>This group can&apos;t be applied to the opened datasets.</>,
        notificationType: RuleNotificationType.WARNING,
      };
    }
  };
